module.exports = __webpack_public_path__ + "img/dots.030d7e0.svg";